// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-sbom.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-sbom',
  title:
    'Maintain a machine-readable Software Bill of Materials for each product with digital elements',
  description:
    'For each product with digital elements (PDE) that is in scope, the manufacturer must draw up and maintain a Software Bill of Materials (SBOM) in a commonly used machine-readable format covering at least the top-level dependencies (CRA Art. 13(5) and Annex I, Part II §1). The SBOM must be kept current across the support period and made available to market surveillance authorities on reasoned request.',
  category: 'assets',
  scfIds: ['SCF-AST-001', 'SCF-VDR-003'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'per-product',
  perProductCriteria: [
    {
      type: 'product-sbom-uploaded',
      description: 'SBOM uploaded (CycloneDX 1.5+ or SPDX 2.3+ JSON)',
    },
  ],
  domainActions: [],
};
